export default "data:image/webp;base64,UklGRjwAAABXRUJQVlA4TDAAAAAvJ4AGACATsIiuiVRuVXxL4FDQtg1T/kyK8OwSZNsMdXwzOdX7PwESPNP+uJwh/wM="